import { render } from "./IncomingTalent.vue?vue&type=template&id=c4c22d3c&ts=true"
import script from "./IncomingTalent.vue?vue&type=script&lang=ts"
export * from "./IncomingTalent.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__